import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewAllBoardsNonFinal: {
		id: 'navigation-apps-sidebar-nav4-jsw-project-menu.jsw-expandable-project.async-content.view-all-boards-non-final',
		defaultMessage: 'View all boards',
		description: 'Link to view all boards',
	},
});
